import Container from './TFAVerificationPage.container';
import TFAVerificationPage from './TFAVerificationPage';

export default Container(TFAVerificationPage);
